import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteTicketCorporateCredit } from '../../../../actions/corporate/TicketCorporateCredit';

const TicketCorporateCreditDeleteButton = ({
  dispatchDeleteTicketCorporateCredit,
  ticketCorporateCreditId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteTicketCorporateCredit({ ticketCorporateCreditId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

TicketCorporateCreditDeleteButton.propTypes = {
  dispatchDeleteTicketCorporateCredit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ticketCorporateCreditId: PropTypes.number.isRequired,
};

TicketCorporateCreditDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteTicketCorporateCredit: deleteTicketCorporateCredit,
};

export default connect(
  null,
  mapDispatchToProps,
)(TicketCorporateCreditDeleteButton);
